import { collection, documentId, getDocs, query, where } from "firebase/firestore";
import { db } from "./firestore";

export const TRACE_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

// Keep the reference join: a mix's stock can point to another product's batch.
export function recentStockBatches(packages, stock, batches, now = Date.now()) {
  const packageById = new Map(packages.map((item) => [item.id, item]));
  return batches.filter((batch) =>
    !batch.canceled &&
    Number.isFinite(batch.harvestDate) &&
    batch.harvestDate >= now - TRACE_WINDOW_MS && batch.harvestDate <= now &&
    (!batch.plantDate || batch.plantDate <= batch.harvestDate)
  ).map((batch) => {
    const matchingPackages = new Map();
    stock.filter((entry) => entry.sourceBatchRef === batch.firebaseId).forEach((entry) => {
      const pack = packageById.get(entry.packageId);
      if (pack) matchingPackages.set(pack.id, pack);
    });
    return { ...batch, packages: [...matchingPackages.values()] };
  }).filter((batch) => batch.packages.length > 0)
    .sort((a, b) => b.harvestDate - a.harvestDate || a.firebaseId.localeCompare(b.firebaseId));
}

async function readMatching(collectionName, field, values) {
  const unique = [...new Set(values.filter(Boolean))];
  const requests = [];
  // Ten values also works with the Firebase version used by this app.
  for (let index = 0; index < unique.length; index += 10) {
    requests.push(getDocs(query(collection(db, collectionName),
      where(field, "in", unique.slice(index, index + 10)))));
  }
  const snapshots = await Promise.all(requests);
  return snapshots.flatMap((snapshot) => snapshot.docs.map((document) => ({
    ...document.data(), firebaseId: document.id,
  })));
}

export async function getFreshProductTrace(product) {
  // Older imports and newer dashboard records can use different product IDs.
  // Include inactive packages: a customer may still be tracing a purchased bag.
  const packages = await readMatching("products_fresh_package", "parentId", [product.id, product.firebaseId]);
  const stock = await readMatching("products_fresh_package_batch", "packageId", packages.map((item) => item.id));
  const batches = await readMatching("products_fresh_batch", documentId(), stock.map((item) => item.sourceBatchRef));
  return recentStockBatches(packages, stock, batches);
}
